// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1xvWa","col":"styles_col__3Wzuf"};